import React, { ReactElement } from 'react';
import { Tooltip, Overlay } from '.';

export const SetReminder = ({ children }: { children: ReactElement }) => (
  <Tooltip delay overlay={<Overlay>Set Reminder</Overlay>} placement="right">
    {children}
  </Tooltip>
);

export const EditReminder = ({ children }: { children: ReactElement }) => (
  <Tooltip delay overlay={<Overlay>Edit Reminder Date</Overlay>} placement="left">
    {children}
  </Tooltip>
);

export const DeleteReminder = ({
  children,
  deletesNote,
}: {
  children: ReactElement;
  deletesNote?: boolean;
}) => (
  <Tooltip
    delay
    overlay={<Overlay>{deletesNote ? 'Delete' : 'Remove'} Reminder</Overlay>}
    placement="right"
  >
    {children}
  </Tooltip>
);

export const AddNoteToReminder = ({ children }: { children: ReactElement }) => (
  <Tooltip delay overlay={<Overlay>Add Note to Reminder</Overlay>} placement="right">
    {children}
  </Tooltip>
);
